module.exports = __webpack_public_path__ + "media/images/atterra-3-1dc88267fd3ae14476a5a8e7a184fb08.jpg";